export default __webpack_public_path__ + "static/media/img-0083-japan-full-face.52915229.png";